import React from 'react';
import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';
import { useTheme } from '../context/ThemeContext.jsx';

const TermsConditions = () => {
  const { 
    colors, 
    spacing, 
    fonts,
    borderRadius,
    shadows
  } = useTheme();

  const pageStyles = {
    minHeight: '100vh',
    backgroundColor: colors.background,
    color: colors.text,
    fontFamily: fonts.families.primary,
    lineHeight: fonts.lineHeights.relaxed,
    transition: 'all 0.3s ease'
  };

  const mainStyles = {
    maxWidth: '900px',
    margin: `${spacing.scale['2xl']} auto`,
    padding: `0 ${spacing.scale.lg}`
  };

  const contentContainerStyles = {
    backgroundColor: colors.surface,
    borderRadius: borderRadius.xl,
    boxShadow: shadows.xl,
    overflow: 'hidden',
    border: `1px solid ${colors.border}`
  };

  const headerSectionStyles = {
    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryHover} 100%)`,
    color: colors.textInverse,
    padding: `${spacing.scale.lg} ${spacing.scale.md}`, // Even smaller padding
    textAlign: 'center'
  };

  const titleStyles = {
    fontSize: fonts.sizes.xl.desktop, // Even smaller title
    marginBottom: spacing.scale.sm, // Minimal margin
    fontWeight: fonts.weights.bold,
    fontFamily: fonts.families.secondary,
    color: '#ffffff', // Force white text
    textShadow: `1px 1px 2px rgba(0, 0, 0, 0.5)` // Add shadow for visibility
  };

  const updatedStyles = {
    fontSize: fonts.sizes.sm.desktop,
    opacity: 0.95,
    backgroundColor: `${colors.info}33`,
    padding: `${spacing.scale.xs} ${spacing.scale.md}`, // Smaller padding
    borderRadius: borderRadius.full,
    display: 'inline-block',
    border: `1px solid ${colors.info}66`,
    color: '#ffffff', // Force white text
    marginBottom: spacing.scale.xs // Minimal margin
  };

  const contentStyles = {
    padding: `${spacing.scale.lg} ${spacing.scale.xl}` // Much smaller top padding
  };

  const tocStyles = {
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.lg,
    padding: spacing.scale.xl,
    marginBottom: spacing.scale['3xl'],
    borderLeft: `4px solid ${colors.secondary}`,
    border: `1px solid ${colors.border}`
  };

  const tocTitleStyles = {
    marginBottom: spacing.scale.lg,
    color: colors.text,
    fontSize: fonts.sizes.xl.desktop,
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.families.secondary
  };

  const tocLinkStyles = {
    color: colors.secondary,
    textDecoration: 'none',
    transition: 'color 0.3s ease'
  };

  const highlightBoxImportantStyles = {
    backgroundColor: `${colors.error}15`,
    border: `1px solid ${colors.error}`,
    borderRadius: borderRadius.md,
    padding: spacing.scale.xl,
    margin: `${spacing.scale.xl} 0`
  };

  const highlightBoxInfoStyles = {
    backgroundColor: `${colors.info}15`,
    border: `1px solid ${colors.info}`,
    borderRadius: borderRadius.md,
    padding: spacing.scale.xl,
    margin: `${spacing.scale.xl} 0`
  };

  const highlightBoxWarningStyles = {
    backgroundColor: `${colors.warning}15`,
    border: `2px solid ${colors.warning}`,
    borderRadius: borderRadius.md,
    padding: spacing.scale.xl,
    margin: `${spacing.scale.xl} 0`
  };

  const sectionStyles = {
    marginBottom: spacing.scale['3xl']
  };

  const sectionHeadingStyles = {
    color: colors.text,
    fontSize: fonts.sizes['2xl'].desktop,
    marginBottom: spacing.scale.xl,
    paddingBottom: spacing.scale.sm,
    borderBottom: `2px solid ${colors.border}`,
    fontFamily: fonts.families.secondary,
    fontWeight: fonts.weights.semibold
  };

  const subHeadingStyles = {
    color: colors.textSecondary,
    fontSize: fonts.sizes.xl.desktop,
    margin: `${spacing.scale.xl} 0 ${spacing.scale.lg} 0`,
    fontWeight: fonts.weights.medium
  };

  const paragraphStyles = {
    marginBottom: spacing.scale.xl,
    fontSize: fonts.sizes.base.desktop,
    color: colors.text,
    lineHeight: fonts.lineHeights.relaxed
  };

  const listStyles = {
    marginBottom: spacing.scale.xl,
    paddingLeft: spacing.scale.xl,
    color: colors.text
  };

  const listItemStyles = {
    marginBottom: spacing.scale.md
  };

  const contactInfoStyles = {
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.lg,
    padding: spacing.scale.xl,
    marginTop: spacing.scale['3xl'],
    textAlign: 'center',
    border: `1px solid ${colors.border}`
  };

  const contactTitleStyles = {
    color: colors.text,
    marginBottom: spacing.scale.lg,
    fontSize: fonts.sizes.xl.desktop,
    fontWeight: fonts.weights.semibold,
    fontFamily: fonts.families.secondary
  };

  const contactLinkStyles = {
    color: colors.secondary,
    textDecoration: 'none',
    fontWeight: fonts.weights.medium,
    transition: 'color 0.3s ease'
  };

  const handleLinkHover = (e) => {
    e.target.style.color = colors.secondaryHover;
  };

  const handleLinkLeave = (e) => {
    e.target.style.color = colors.secondary;
  };

  const handleTocLinkHover = (e) => {
    e.target.style.color = colors.secondaryHover;
  };

  const handleTocLinkLeave = (e) => {
    e.target.style.color = colors.secondary;
  };

  return (
    <div style={pageStyles}>
      <Header showBreadcrumb={false} />
      
      <main style={mainStyles}>
        <div style={contentContainerStyles}>
          <section style={headerSectionStyles}>
            <h1 style={titleStyles}>Terms and Conditions</h1>
            <div style={updatedStyles}>Last Updated: July 16, 2026</div>
            {/* <div style={{ marginTop: spacing.scale.xs }}>
              <DocumentDownload 
                document={{
                  name: "Terms and Conditions",
                  filename: "terms-conditions",
                  type: "terms"
                }}
              />
            </div> */}
            <div style={{ marginTop: spacing.scale.xs, display: 'flex', justifyContent: 'center' }}>
              <button
                onClick={() => window.print()}
                style={{
                  backgroundColor: colors.secondary,
                  color: colors.textOnAccent,
                  border: 'none',
                  padding: `${spacing.scale.sm} ${spacing.scale.lg}`,
                  borderRadius: borderRadius.md,
                  fontSize: fonts.sizes.sm.desktop,
                  fontWeight: fonts.weights.medium,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: spacing.scale.xs
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.secondaryHover;
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = colors.secondary;
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                🖨️ Print Document
              </button>
            </div>
          </section>

          <div style={contentStyles}>
            <section style={tocStyles}>
              <h2 style={tocTitleStyles}>Table of Contents</h2>
              <ol style={{ paddingLeft: spacing.scale.xl }}>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#the-basics" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>The Basics</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#what-we-offer" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>What We Offer</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#absolutely-prohibited" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>What's Absolutely Prohibited</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#age-requirements" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Age Requirements</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#payment-terms" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Payment Terms</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#software-licensing" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Software Licensing</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#digital-content" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Digital Content Rules</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#credits" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Credits & In-App Purchases</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#intellectual-property" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Intellectual Property</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#privacy-data" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Privacy & Your Data</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#liability-limits" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>What We're Responsible For</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#termination" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>When Things End</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#legal-stuff" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Legal Stuff</a>
                </li>
                <li style={{ marginBottom: spacing.scale.sm }}>
                  <a href="#contact-us" style={tocLinkStyles} onMouseEnter={handleTocLinkHover} onMouseLeave={handleTocLinkLeave}>Questions?</a>
                </li>
              </ol>
            </section>

            <div style={highlightBoxImportantStyles}>
              <h3 style={{ marginTop: 0, color: colors.error, fontWeight: fonts.weights.semibold }}>Zero Tolerance Policy</h3>
              <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                <strong>Our products are NOT to be used for any criminal activity, illegal purposes, or in support of illegal activities.</strong> We take this seriously and will immediately terminate accounts and report suspected criminal use to appropriate authorities.
              </p>
            </div>

            <section style={sectionStyles} id="the-basics">
              <h2 style={sectionHeadingStyles}>1. The Basics</h2>
              
              <p style={paragraphStyles}>
                Welcome! These terms govern your use of LondaLab products and services. By using our apps, purchasing credits or subscriptions, or using any of our online services, you agree to these terms.
              </p>
              
              <p style={paragraphStyles}>
                <strong>Simple version:</strong> At LondaLab, we create Human Centered Intelligent Apps for amazing people like you. These terms help protect our creative work and ensure a great experience for our entire community.
              </p>

              <div style={highlightBoxInfoStyles}>
                <h3 style={{ color: colors.info, marginTop: 0, fontWeight: fonts.weights.semibold }}>What This Covers</h3>
                <ul style={listStyles}>
                  <li style={listItemStyles}>All apps and software we publish</li>
                  <li style={listItemStyles}>In-app purchases, credits, and subscriptions</li>
                  <li style={listItemStyles}>Digital content within our apps</li>
                  <li style={listItemStyles}>Our website and any online services</li>
                  <li style={listItemStyles}>Support and documentation</li>
                </ul>
              </div>
            </section>

            <section style={sectionStyles} id="what-we-offer">
              <h2 style={sectionHeadingStyles}>2. What We Offer</h2>

              <h3 style={subHeadingStyles}>Our Apps</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Mobile Apps:</strong> iOS and Android applications published by LondaLab</li>
                <li style={listItemStyles}><strong>Web Applications:</strong> Browser-based apps and companion tools</li>
                <li style={listItemStyles}><strong>Everyday Life & Learning:</strong> Apps for daily routines, skills, and personal growth</li>
                <li style={listItemStyles}><strong>Small Business Tools:</strong> Intelligent, agentic apps that help small businesses and sole proprietors get noticed</li>
              </ul>

              <h3 style={subHeadingStyles}>Credits, Subscriptions & In-App Purchases</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Credit-Based Access:</strong> Many of our apps use credits that you purchase and spend on features</li>
                <li style={listItemStyles}><strong>Subscriptions:</strong> Some apps and services bill on a recurring basis</li>
                <li style={listItemStyles}><strong>In-App Content:</strong> Creative elements and digital assets within our applications</li>
              </ul>
            </section>

            <section style={sectionStyles} id="absolutely-prohibited">
              <h2 style={sectionHeadingStyles}>3. What's Absolutely Prohibited</h2>
              
              <div style={highlightBoxWarningStyles}>
                <h3 style={{ marginTop: 0, color: colors.warning, fontWeight: fonts.weights.semibold }}>Criminal Activity = Immediate Ban</h3>
                <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                  We have <strong>ZERO TOLERANCE</strong> for criminal use of our products. This includes but is not limited to:
                </p>
              </div>

              <h3 style={subHeadingStyles}>Absolutely Forbidden Uses:</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Any illegal activity</strong> - fraud, theft, hacking, etc.</li>
                <li style={listItemStyles}><strong>Supporting criminal organizations</strong> - no matter how indirectly</li>
                <li style={listItemStyles}><strong>Money laundering</strong> or financial crimes</li>
                <li style={listItemStyles}><strong>Drug trafficking</strong> or illegal substance distribution</li>
                <li style={listItemStyles}><strong>Human trafficking</strong> or exploitation</li>
                <li style={listItemStyles}><strong>Terrorism</strong> or violent extremism</li>
                <li style={listItemStyles}><strong>Child exploitation</strong> of any kind</li>
                <li style={listItemStyles}><strong>Harassment, doxxing, or stalking</strong></li>
                <li style={listItemStyles}><strong>Creating malware</strong> or harmful software</li>
                <li style={listItemStyles}><strong>Copyright infringement</strong> or piracy</li>
                <li style={listItemStyles}><strong>Violating export laws</strong> or sanctions</li>
              </ul>

              <h3 style={subHeadingStyles}>What Happens If You Break These Rules:</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Immediate account termination</strong> - no warnings, no refunds</li>
                <li style={listItemStyles}><strong>All access revoked</strong> - software, content, everything</li>
                <li style={listItemStyles}><strong>Reported to authorities</strong> - we cooperate fully with law enforcement</li>
                <li style={listItemStyles}><strong>Legal action</strong> - we will pursue damages and injunctive relief</li>
                <li style={listItemStyles}><strong>Permanently banned</strong> - you can never use our products again</li>
              </ul>

              <p style={paragraphStyles}>
                <strong>We mean it.</strong> We monitor for suspicious activity and work with law enforcement. Don't test us on this.
              </p>
            </section>

            <section style={sectionStyles} id="age-requirements">
              <h2 style={sectionHeadingStyles}>4. Age Requirements</h2>
              
              <h3 style={subHeadingStyles}>Minimum Age: 13</h3>
              <p style={paragraphStyles}>
                You must be at least 13 years old to use our products. This is for legal compliance and because our content is rated PG-13 minimum.
              </p>

              <h3 style={subHeadingStyles}>Under 18?</h3>
              <p style={paragraphStyles}>If you're under 18, you need parent or guardian permission to:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}>Make purchases</li>
                <li style={listItemStyles}>Create accounts</li>
                <li style={listItemStyles}>Use services that collect personal information</li>
                <li style={listItemStyles}>Download or install our software</li>
              </ul>

              <h3 style={subHeadingStyles}>Content Rating</h3>
              <p style={paragraphStyles}>Our digital content is rated <strong>PG-13 minimum</strong>. This means:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}>May contain mild profanity</li>
                <li style={listItemStyles}>Some suggestive themes</li>
                <li style={listItemStyles}>Mild violence or intense situations</li>
                <li style={listItemStyles}>Complex topics requiring maturity</li>
              </ul>
            </section>

            <section style={sectionStyles} id="payment-terms">
              <h2 style={sectionHeadingStyles}>5. Payment Terms</h2>
              
              <h3 style={subHeadingStyles}>Pricing & Payment</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>All prices in USD</strong> unless otherwise specified</li>
                <li style={listItemStyles}><strong>Credits and in-app purchases</strong> are paid up front</li>
                <li style={listItemStyles}><strong>Subscription services</strong> bill automatically</li>
                <li style={listItemStyles}><strong>App store purchases</strong> are billed through Apple or Google and follow their payment terms</li>
              </ul>

              <h3 style={subHeadingStyles}>Refunds</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Apps & subscriptions:</strong> 30-day refund period if the software doesn't work as described</li>
                <li style={listItemStyles}><strong>Credits & in-app purchases:</strong> Refunds within 14 days if the feature is fundamentally broken</li>
                <li style={listItemStyles}><strong>App store purchases:</strong> Handled under Apple and Google refund policies</li>
              </ul>

              <h3 style={subHeadingStyles}>No Refunds For:</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}>Account termination due to violations</li>
                <li style={listItemStyles}>Change of mind after using the app or spending credits</li>
                <li style={listItemStyles}>Compatibility issues we disclosed upfront</li>
              </ul>
            </section>

            <section style={sectionStyles} id="software-licensing">
              <h2 style={sectionHeadingStyles}>6. Software Licensing</h2>
              
              <h3 style={subHeadingStyles}>What You Get</h3>
              <p style={paragraphStyles}>
                When you buy our software, you get a <strong>license to use it</strong> - you don't own the software itself. Think of it like buying a movie ticket: you can watch the movie, but you don't own the theater.
              </p>

              <h3 style={subHeadingStyles}>Your License Includes:</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Personal or business use</strong> as specified in your purchase</li>
                <li style={listItemStyles}><strong>Installation on permitted devices</strong></li>
                <li style={listItemStyles}><strong>Updates and bug fixes</strong> during the license period</li>
                <li style={listItemStyles}><strong>Basic technical support</strong></li>
              </ul>

              <h3 style={subHeadingStyles}>You Cannot:</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Reverse engineer</strong> or decompile the software</li>
                <li style={listItemStyles}><strong>Redistribute or resell</strong> our software</li>
                <li style={listItemStyles}><strong>Remove copyright notices</strong> or branding</li>
                <li style={listItemStyles}><strong>Use beyond license limits</strong> (users, devices, etc.)</li>
                <li style={listItemStyles}><strong>Create derivative works</strong> without permission</li>
              </ul>

              <h3 style={subHeadingStyles}>Open Source Components</h3>
              <p style={paragraphStyles}>
                Our software may include open source components. Those components remain under their original licenses, which we'll provide upon request.
              </p>
            </section>

            <section style={sectionStyles} id="digital-content">
              <h2 style={sectionHeadingStyles}>7. Digital Content Rules</h2>
              
              <h3 style={subHeadingStyles}>Small Business Tools</h3>
              <p style={paragraphStyles}>Our apps built for small businesses and sole proprietors are licensed for commercial use:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Use in your business</strong> - exactly what it's designed for!</li>
                <li style={listItemStyles}><strong>Process your business data</strong> - that's the whole point</li>
                <li style={listItemStyles}><strong>Generate business insights</strong> - go make money with our tools</li>
                <li style={listItemStyles}><strong>Scale with your team</strong> - within your license limits</li>
              </ul>

              <h3 style={subHeadingStyles}>Personal & Creative Content</h3>
              <p style={paragraphStyles}>The stories, games, and creative content within our apps are licensed for personal enjoyment:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Enjoy it personally</strong> - read, play, experience</li>
                <li style={listItemStyles}><strong>Share your thoughts</strong> - reviews, discussions, fair use commentary</li>
                <li style={listItemStyles}><strong>Create fan content</strong> - within reasonable fair use limits</li>
              </ul>

              <h3 style={subHeadingStyles}>What You Cannot Do (All Content Types):</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Redistribute our software/content</strong> - no sharing files or accounts</li>
                <li style={listItemStyles}><strong>Circumvent access controls</strong> - no hacking or cracking</li>
                <li style={listItemStyles}><strong>Resell our products</strong> - you can't become a reseller without permission</li>
                <li style={listItemStyles}><strong>Remove licensing/copyright notices</strong> - keep our credits intact</li>
                <li style={listItemStyles}><strong>Reverse engineer</strong> - except where legally permitted</li>
              </ul>

              <h3 style={subHeadingStyles}>User-Generated Content</h3>
              <p style={paragraphStyles}>If our software or platforms allow you to create content:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>You own your original creations</strong></li>
                <li style={listItemStyles}><strong>You grant us license to host/display</strong> your content</li>
                <li style={listItemStyles}><strong>Follow the same prohibition rules</strong> - no illegal or harmful content</li>
                <li style={listItemStyles}><strong>We can remove content</strong> that violates these terms</li>
              </ul>
            </section>

            <section style={sectionStyles} id="credits">
              <h2 style={sectionHeadingStyles}>8. Credits & In-App Purchases</h2>

              <h3 style={subHeadingStyles}>How Credits Work</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Purchase and spend:</strong> You buy credits in an app and spend them on features and content</li>
                <li style={listItemStyles}><strong>Tied to your account:</strong> Credits are non-transferable between accounts</li>
                <li style={listItemStyles}><strong>No cash value:</strong> Credits cannot be exchanged for cash or used outside our apps</li>
              </ul>

              <h3 style={subHeadingStyles}>App Store Purchases</h3>
              <p style={paragraphStyles}>
                Purchases made through the Apple App Store or Google Play are billed by those stores and follow their payment and refund policies.
              </p>

              <h3 style={subHeadingStyles}>Promotional Credits</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Coupons and promotions:</strong> We may grant free or discounted credits at our discretion</li>
                <li style={listItemStyles}><strong>May expire:</strong> Promotional credits can have expiration dates or usage conditions</li>
                <li style={listItemStyles}><strong>Something go wrong?</strong> If credits you purchased don't show up or a feature fails, contact us and we'll make it right</li>
              </ul>
            </section>

            <section style={sectionStyles} id="intellectual-property">
              <h2 style={sectionHeadingStyles}>9. Intellectual Property</h2>
              
              <h3 style={subHeadingStyles}>Our Stuff</h3>
              <p style={paragraphStyles}>We own or license all the intellectual property in our products:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Software code and architecture</strong></li>
                <li style={listItemStyles}><strong>Story content and characters</strong></li>
                <li style={listItemStyles}><strong>Art, graphics, and designs</strong></li>
                <li style={listItemStyles}><strong>Trademarks and branding</strong></li>
                <li style={listItemStyles}><strong>Documentation and tutorials</strong></li>
              </ul>

              <h3 style={subHeadingStyles}>Respecting Others</h3>
              <p style={paragraphStyles}>We respect intellectual property rights and expect you to do the same. If you believe our content infringes your rights, contact us with:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}>Description of the copyrighted work</li>
                <li style={listItemStyles}>Location of the allegedly infringing content</li>
                <li style={listItemStyles}>Your contact information</li>
                <li style={listItemStyles}>Statement of good faith belief</li>
                <li style={listItemStyles}>Statement under penalty of perjury</li>
                <li style={listItemStyles}>Electronic or physical signature</li>
              </ul>

              <h3 style={subHeadingStyles}>DMCA Compliance</h3>
              <p style={paragraphStyles}>
                We comply with the Digital Millennium Copyright Act. Send DMCA notices to: <strong>hello@londalab.com</strong>
              </p>
            </section>

            <section style={sectionStyles} id="privacy-data">
              <h2 style={sectionHeadingStyles}>10. Privacy & Your Data</h2>
              
              <h3 style={subHeadingStyles}>What We Collect</h3>
              <p style={paragraphStyles}>We collect only what we need to provide our services:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Account information</strong> - name, email, payment details</li>
                <li style={listItemStyles}><strong>Usage data</strong> - how you use our software (to improve it)</li>
                <li style={listItemStyles}><strong>Support communications</strong> - when you contact us for help</li>
                <li style={listItemStyles}><strong>Basic analytics</strong> - website traffic and performance</li>
              </ul>

              <h3 style={subHeadingStyles}>What We Don't Do</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Sell your data</strong> - never, ever</li>
                <li style={listItemStyles}><strong>Spam you</strong> - only necessary communications</li>
                <li style={listItemStyles}><strong>Track excessively</strong> - minimal analytics only</li>
                <li style={listItemStyles}><strong>Share without permission</strong> - except when required by law</li>
              </ul>

              <p style={paragraphStyles}>
                For complete details, see our <a 
                  href="/privacy-policy" 
                  style={{ color: colors.secondary, textDecoration: 'none' }}
                  onMouseEnter={handleLinkHover}
                  onMouseLeave={handleLinkLeave}
                >Privacy Policy</a>.
              </p>
            </section>

            <section style={sectionStyles} id="liability-limits">
              <h2 style={sectionHeadingStyles}>11. What We're Responsible For</h2>
              
              <h3 style={subHeadingStyles}>Our Promise</h3>
              <p style={paragraphStyles}>We promise to:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Deliver working software</strong> that meets our specifications</li>
                <li style={listItemStyles}><strong>Provide described features</strong> and content</li>
                <li style={listItemStyles}><strong>Fix bugs</strong> and provide reasonable support</li>
                <li style={listItemStyles}><strong>Protect your data</strong> with reasonable security measures</li>
                <li style={listItemStyles}><strong>Honor refund policies</strong> as stated</li>
              </ul>

              <h3 style={subHeadingStyles}>Reality Check</h3>
              <p style={paragraphStyles}>Software is complex, and we're human. We can't guarantee:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>100% uptime</strong> - servers sometimes go down</li>
                <li style={listItemStyles}><strong>Bug-free code</strong> - we fix issues as we find them</li>
                <li style={listItemStyles}><strong>Compatibility</strong> with every possible system configuration</li>
                <li style={listItemStyles}><strong>Unlimited support</strong> - we provide reasonable assistance</li>
                <li style={listItemStyles}><strong>Future availability</strong> - we may discontinue products</li>
              </ul>

              <h3 style={subHeadingStyles}>Limitation of Liability</h3>
              <p style={paragraphStyles}>
                If something goes wrong that's our fault, our liability is limited to the amount you paid for the specific product. We're not liable for:
              </p>
              <ul style={listStyles}>
                <li style={listItemStyles}>Lost profits or business opportunities</li>
                <li style={listItemStyles}>Data loss (keep backups!)</li>
                <li style={listItemStyles}>Indirect or consequential damages</li>
                <li style={listItemStyles}>Issues caused by misuse of our products</li>
              </ul>

              <p style={paragraphStyles}>
                <strong>Translation:</strong> If our $10 app breaks, you can get your $10 back, but we're not buying you a new computer.
              </p>
            </section>

            <section style={sectionStyles} id="termination">
              <h2 style={sectionHeadingStyles}>12. When Things End</h2>
              
              <h3 style={subHeadingStyles}>You Can Leave Anytime</h3>
              <p style={paragraphStyles}>
                You can stop using our products whenever you want. For subscriptions, cancel before your next billing cycle to avoid charges.
              </p>

              <h3 style={subHeadingStyles}>When We End Things</h3>
              <p style={paragraphStyles}>We can terminate accounts for:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Violation of these terms</strong> - especially criminal activity</li>
                <li style={listItemStyles}><strong>Non-payment</strong> - if you don't pay what you owe</li>
                <li style={listItemStyles}><strong>Abuse of support</strong> - being unreasonably demanding or abusive</li>
                <li style={listItemStyles}><strong>Fraudulent activity</strong> - chargebacks, fake information, etc.</li>
              </ul>

              <h3 style={subHeadingStyles}>What Happens After Termination</h3>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>Software stops working</strong> - no more updates or support</li>
                <li style={listItemStyles}><strong>Subscription services end</strong> - ongoing services are discontinued</li>
                <li style={listItemStyles}><strong>Account access may be limited</strong> - access to purchased content varies by product type</li>
                <li style={listItemStyles}><strong>Data may be deleted</strong> - download what you need first</li>
                <li style={listItemStyles}><strong>No refunds</strong> for violations</li>
              </ul>

              <h3 style={subHeadingStyles}>Discontinued Products</h3>
              <p style={paragraphStyles}>Sometimes we have to discontinue products. When that happens:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>90 days notice</strong> when possible</li>
                <li style={listItemStyles}><strong>Final updates</strong> to ensure stability</li>
                <li style={listItemStyles}><strong>Data export tools</strong> when applicable</li>
                <li style={listItemStyles}><strong>No ongoing support</strong> after discontinuation</li>
              </ul>
            </section>

            <section style={sectionStyles} id="legal-stuff">
              <h2 style={sectionHeadingStyles}>13. Legal Stuff</h2>
              
              <h3 style={subHeadingStyles}>Governing Law</h3>
              <p style={paragraphStyles}>
                These terms are governed by California law. Any disputes will be resolved in California courts.
              </p>

              <h3 style={subHeadingStyles}>Dispute Resolution</h3>
              <p style={paragraphStyles}>If we have a disagreement:</p>
              <ol style={listStyles}>
                <li style={listItemStyles}><strong>Talk to us first</strong> - contact support to resolve issues</li>
                <li style={listItemStyles}><strong>Try mediation</strong> - we'll attempt good faith negotiation</li>
                <li style={listItemStyles}><strong>Small claims court</strong> - for smaller disputes</li>
                <li style={listItemStyles}><strong>Arbitration</strong> - for larger disputes (individual basis only, no class actions)</li>
              </ol>

              <h3 style={subHeadingStyles}>Changes to These Terms</h3>
              <p style={paragraphStyles}>We may update these terms occasionally. When we do:</p>
              <ul style={listStyles}>
                <li style={listItemStyles}><strong>30 days notice</strong> for material changes</li>
                <li style={listItemStyles}><strong>Email notification</strong> to active users</li>
                <li style={listItemStyles}><strong>Website posting</strong> with effective date</li>
                <li style={listItemStyles}><strong>Continued use</strong> means you accept the changes</li>
              </ul>

              <h3 style={subHeadingStyles}>Severability</h3>
              <p style={paragraphStyles}>
                If any part of these terms is found invalid, the rest still applies.
              </p>

              <h3 style={subHeadingStyles}>No Waiver</h3>
              <p style={paragraphStyles}>
                Just because we don't immediately enforce something doesn't mean we've waived our rights.
              </p>
            </section>

            <section style={sectionStyles} id="contact-us">
              <h2 style={sectionHeadingStyles}>14. Questions?</h2>
              
              <div style={contactInfoStyles}>
                <h3 style={contactTitleStyles}>Get In Touch</h3>
                <p style={paragraphStyles}>Questions about these terms? Need help with our products? We're here to help:</p>
                <p style={paragraphStyles}>
                  <strong>General Questions:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleLinkHover}
                    onMouseLeave={handleLinkLeave}
                  >hello@londalab.com</a><br />
                  <strong>Legal/Terms Questions:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleLinkHover}
                    onMouseLeave={handleLinkLeave}
                  >hello@londalab.com</a><br />
                  <strong>DMCA Notices:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleLinkHover}
                    onMouseLeave={handleLinkLeave}
                  >hello@londalab.com</a><br />
                  <strong>Report Criminal Activity:</strong> <a 
                    href="mailto:hello@londalab.com" 
                    style={contactLinkStyles}
                    onMouseEnter={handleLinkHover}
                    onMouseLeave={handleLinkLeave}
                  >hello@londalab.com</a>
                </p>
                <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                  <strong>LondaLab</strong>, a Victoria Londe brand<br />
                  2883 Hopyard Rd<br />
                  Pleasanton, CA 94588
                </p>
              </div>
            </section>

            <div style={highlightBoxInfoStyles}>
              <h3 style={{ color: colors.info, marginTop: 0, fontWeight: fonts.weights.semibold }}>The Bottom Line</h3>
              <p style={{ ...paragraphStyles, marginBottom: 0 }}>
                We want to create great software and content while maintaining a safe, legal community. Use our products responsibly, don't do illegal stuff, and we'll get along great. If you have questions, just ask - we're friendly people who happen to take legal compliance very seriously.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsConditions;